module.exports = __webpack_public_path__ + "static/media/promoCode.0e0d5fdd.svg";